var map = {
	"./Birthday-Cake.jpg": 8375,
	"./Chocolate-Fully-Iced.jpg": 7258,
	"./Cookie-Cake-Base.jpg": 3244,
	"./Double-Fudge.jpg": 4354,
	"./Icing-Cake.jpg": 4602,
	"./MM copy.jpg": 6806,
	"./MM.jpg": 8829,
	"./Oatmeal-Walnut-Raisin.jpg": 8725,
	"./Original-Chocolate-Chip.jpg": 7232,
	"./Sugar-Cake.jpg": 9660,
	"./Vanilla-Fully-Iced.jpg": 1387,
	"./m-birthday-cake-mm.jpg": 7422,
	"./m-double-fudge-mm.jpg": 9873,
	"./m-oatmeal-walnut-raisin-mm.jpg": 3160,
	"./m-original-chocolate-chip-mm.jpg": 9587,
	"./m-sugar-cake-mm.jpg": 1579
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2695;